import { render, staticRenderFns } from "./PublicAgree.vue?vue&type=template&id=03322005&scoped=true&"
import script from "./PublicAgree.vue?vue&type=script&lang=js&"
export * from "./PublicAgree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03322005",
  null
  
)

export default component.exports